/* Diamond Domain - family cards on collection grids (Sep 2026).

   359 of 428 ring listings are 43 designs. A collection therefore shows the same setting up
   to ten times in a row, once per diamond shape, which is why the grid reads as repetitive.
   This collapses each family to ONE card and hangs the other shapes off it as links.

   ON SEO. Nothing is removed from the HTML. Duplicate cards are hidden with CSS, so their
   links are still in the source, and the surviving card GAINS a link to every sibling. The
   page ends up with MORE internal links than before, not fewer. Deleting those tiles server
   side would have removed ~316 internal links from indexed pages, which is why it is not done
   that way.

   Finding the product id: the theme builds each card's id as
     product-item--{section}-{block}-{product.id}--{timestamp}
   Block ids may be empty, so splitting on separators is unreliable. Product ids are 13 digits
   and the timestamp is 10, so the first run of 13+ digits is the product id.

   NOTE ON BACKSLASHES: these files are written through a GraphQL block string, which passes
   backslashes through VERBATIM. A regex written as \\s or \\d arrives as a literal backslash
   and never matches. That mistake has been made three times in this project; every regex here
   uses single backslashes.

   Delete this file and its line in layout/theme.liquid to revert. */
(function () {
  var SHAPE_ORDER = ['Round', 'Oval', 'Cushion', 'Emerald', 'Pear', 'Princess',
                     'Radiant', 'Marquise', 'Heart', 'Asscher'];

  function productIdOf(card) {
    var m = String(card.id || '').match(/\d{13,}/);
    return m ? m[0] : null;
  }

  function buildIndex() {
    var raw = document.getElementById('dd-family-map');
    if (!raw) return null;

    var families;
    try { families = JSON.parse(raw.textContent); } catch (e) { return null; }
    if (!families || !families.length) return null;

    var byProduct = {};
    families.forEach(function (fam) {
      (fam.members || []).forEach(function (m) { byProduct[String(m.id)] = fam; });
    });
    return byProduct;
  }

  function swatchRow(fam, currentId) {
    var wrap = document.createElement('div');
    wrap.className = 'dd-fam';

    var members = (fam.members || []).slice().sort(function (a, b) {
      var ia = SHAPE_ORDER.indexOf(a.shape);
      var ib = SHAPE_ORDER.indexOf(b.shape);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });

    var row = document.createElement('div');
    row.className = 'dd-fam__row';

    members.forEach(function (m) {
      var a = document.createElement('a');
      a.className = 'dd-fam__swatch' +
        (String(m.id) === String(currentId) ? ' is-current' : '') +
        (m.available === false ? ' is-soldout' : '');
      a.href = m.url;
      a.setAttribute('aria-label', m.title || m.shape);
      a.setAttribute('data-dd-shape', m.shape || '');

      if (m.img) {
        var img = document.createElement('img');
        img.src = m.img;
        img.alt = (m.shape || '') + ' cut';
        img.width = 160;
        img.height = 160;
        img.loading = 'lazy';
        a.appendChild(img);
      }
      row.appendChild(a);
    });

    var note = document.createElement('p');
    note.className = 'dd-fam__note';
    note.textContent = members.length + ' diamond shapes';

    wrap.appendChild(note);
    wrap.appendChild(row);
    return wrap;
  }

  function run() {
    var cards = document.querySelectorAll('.product-grid-item[data-product-block]');
    if (!cards.length) return false;

    var index = buildIndex();
    if (!index) return true;                /* no families on this page - nothing to collapse */

    var shown = {};
    var collapsed = 0;
    var visible = 0;

    [].forEach.call(cards, function (card) {
      if (card.dataset.ddFam === '1') {
        if (!card.classList.contains('dd-fam-dupe')) visible++;
        return;
      }

      var pid = productIdOf(card);
      if (!pid) return;

      var fam = index[pid];
      if (!fam) { card.dataset.ddFam = '1'; visible++; return; }

      if (shown[fam.key]) {
        /* a later member of a family already on this page: hide it, but leave it in the DOM
           so its link stays in the source */
        card.classList.add('dd-fam-dupe');
        card.setAttribute('aria-hidden', 'true');
        card.dataset.ddFam = '1';
        collapsed++;
        return;
      }

      shown[fam.key] = true;
      var info = card.querySelector('.product-grid-item__info');
      if (info) info.appendChild(swatchRow(fam, pid));
      card.classList.add('dd-fam-lead');
      card.dataset.ddFam = '1';
      visible++;
    });

    if (collapsed) retitleCount(visible);
    return true;
  }

  /* "22 products" is no longer what the grid shows. Say what it does show. */
  function retitleCount(visible) {
    var el = document.querySelector('[data-products-count], .collection__showing, .collection-count');

    if (!el) {
      var all = document.querySelectorAll('main span, main p, main div');
      for (var i = 0; i < all.length; i++) {
        if (all[i].children.length === 0 && /^\s*\d+\s+products?\s*$/i.test(all[i].textContent)) {
          el = all[i];
          break;
        }
      }
    }

    if (!el || el.dataset.ddCount === '1') return;
    el.textContent = visible + (visible === 1 ? ' design' : ' designs');
    el.dataset.ddCount = '1';
  }

  function start() {
    run();
    var tries = 0;
    var timer = setInterval(function () {
      run();                                 /* grids re-render on filter and sort */
      if (++tries > 24) clearInterval(timer);
    }, 350);

    var host = document.querySelector('main.main-content');
    if (host && window.MutationObserver) {
      var busy = false;
      var t = null;
      new MutationObserver(function () {
        if (busy) return;
        clearTimeout(t);
        t = setTimeout(function () {
          busy = true;
          run();
          setTimeout(function () { busy = false; }, 80);
        }, 150);
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();